module.exports = __webpack_public_path__ + "img/edge_restauration_viande.677814b5.svg";